export default "__VITE_ASSET__17754fd7__"